import { render, staticRenderFns } from "./notificationsList.vue?vue&type=template&id=34f63028&scoped=true&"
import script from "./notificationsList.vue?vue&type=script&lang=js&"
export * from "./notificationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f63028",
  null
  
)

export default component.exports